import React from 'react';

export const FloatingHeader = () => (
    <div className="absolute top-8 left-8 z-10 pointer-events-none select-none">
        <h1 className="text-5xl font-black text-gray-900 tracking-tighter mb-1 drop-shadow-sm">NRCF</h1>
        <p className="text-sm font-bold text-gray-500 tracking-widest uppercase">Normative Reinforcement Control Framework</p>
        <div className="mt-6 flex items-center gap-2 animate-pulse">
            <div className="w-2 h-2 bg-blue-500 rounded-full shadow-[0_0_8px_rgba(59,130,246,0.6)]"></div>
            <span className="text-xs font-bold text-blue-600 uppercase tracking-wider">Interactive Model</span>
        </div>
    </div>
);
